<template>
  <v-widget title="Progress Client">
    <div slot="widget-content">
      <div
        v-if="client_init"
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <v-progress-circular
          indeterminate
          :size="40"
          :width="2"
          color="secondary"
        >
        </v-progress-circular>
      </div>
      <div v-else-if="clients_progress.length">
        <vue-perfect-scrollbar style="max-height: 450px">
          <v-list three-line dense class="pa-0">
            <v-list-tile
              v-for="(item, index) in simple_clients_progress"
              avatar
              v-ripple
              :key="`client-progress-${index}`"
              :to="{ name: 'ClientList', query: { id: item.id_client } }"
            >
              <v-progress-circular
                :size="50"
                :width="5"
                :rotate="parseInt(item.target_per_tahun)"
                :value="item.progress"
                class="mr-2"
                color="secondary"
              >
                {{ item.total_training }}
              </v-progress-circular>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.client }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  <span v-if="item.kab_kota">{{ item.kab_kota }}, </span
                  >{{ item.area }}</v-list-tile-sub-title
                >
                <v-list-tile-sub-title
                  >Terakhir :
                  {{
                    item.last_training | moment("from", "now")
                  }}</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </vue-perfect-scrollbar>
        <v-divider></v-divider>
        <v-btn block flat class="ma-0" @click="nToggle">
          {{ nLocal == -1 ? "Sedikit" : "Banyak" }}
          <v-icon>{{
            nLocal == -1 ? "keyboard_arrow_up" : "keyboard_arrow_down"
          }}</v-icon>
        </v-btn>
      </div>
      <div
        v-else
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <h2>Belum ada data.</h2>
        <v-icon medium>sentiment_very_dissatisfied</v-icon>
      </div>
    </div>
  </v-widget>
</template>

<script>
import _ from "lodash";
import VWidget from "@/components/widgets/VWidget";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState } from "vuex";

export default {
  name: "client-progress",
  props: {
    n: {
      type: Number,
      default: 5
    }
  },
  components: {
    VWidget,
    VuePerfectScrollbar
  },
  data() {
    return {
      nLocal: -1,
      year: this.$moment().year()
    };
  },
  computed: {
    ...mapState("client", ["client_init"]),
    clients_progress() {
      let clients = _.cloneDeep(
        this.$store.getters["client/clientByLamanPeriode"]
      );
      clients = clients.filter(c => {
        return parseInt(c.active_client);
      });
      for (let i = 0; i < clients.length; i++) {
        clients[i].progress =
          clients[i].target_per_tahun > 0
            ? // eslint-disable-next-line
              (clients[i].total_training / clients[i].target_per_tahun) * 100
            : 100;
        clients[i].last_training =
          clients[i].total_training > 0
            ? _.maxBy(clients[i].training, "waktu_mulai").waktu_mulai
            : "belum pernah";
      }
      return _.orderBy(
        clients,
        [
          t => {
            return parseInt(t.progress);
          },
          t => {
            return parseInt(t.total_training);
          }
        ],
        ["asc", "asc"]
      );
    },
    simple_clients_progress() {
      return this.clients_progress.filter(
        (_, i) => i < this.nLocal || this.nLocal < 0
      );
    }
  },
  methods: {
    nToggle() {
      if (this.nLocal == -1) this.nLocal = _.cloneDeep(this.n);
      else this.nLocal = -1;
    }
  },
  mounted() {
    this.nLocal = _.cloneDeep(this.n);
  }
};
</script>
